export enum CookieName {
  Advertising = 'GT_Advertising',
  AllowedSettings = 'GT_AllowedSettings',
  Performance = 'GT_Performance',
  Required = 'GT_Required',
}
